import { c as _c } from "react/compiler-runtime";
import { FiAlertTriangle } from "react-icons/fi";
import Tooltip from "@/components/ui/tooltip";
export default function UnscreenedMarker(t0) {
  const $ = _c(3);
  const {
    kind
  } = t0;
  const t1 = `E-prescribing doesn't recognize this ${kind}, so it can't warn about it when prescribing. Edit it to the standard name to turn on checks.`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="ml-2 inline-flex align-middle text-status-warning-text" aria-label="Not checked when prescribing"><FiAlertTriangle className="h-4 w-4" /></span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <Tooltip triggerAsChild={true} content={t1}>{t2}</Tooltip>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}